/**
 * Shared brand option constants.
 *
 * Single source of truth for the hardcoded category and sector option lists
 * used across the Brands feature (listing filter UI, brand edit form, and the
 * client/prospect search panel in proposals).
 *
 * Values must remain byte-identical with the `enums.category.*` and
 * `enums.sector.*` keys in `client/src/translations/{en,es,de}/common.json`.
 * The label for each value is rendered via `t(`enums.category.${val}`)` or
 * `t(`enums.sector.${val}`)`.
 */

export const CATEGORY_OPTIONS = [
  'real_estate',
  'legal',
  'fintech',
  'broker',
  'bank',
  'crowdfunding',
  'loans',
  'roboadvisor',
  'software',
  'generalist',
  'exchange',
];

export const SECTOR_OPTIONS = [
  'technology',
  'software',
  'artificial_intelligence',
  'cybersecurity',
  'semiconductors',
  'telecommunications',
  'media',
  'advertising_and_marketing',
  'retail',
  'ecommerce',
  'consumer_discretionary',
  'consumer_staples',
  'food_and_beverage',
  'fashion_and_luxury',
  'health',
  'biotechnology',
  'pharmaceuticals',
  'medical_devices',
  'financial_services',
  'banking',
  'insurance',
  'asset_management',
  'fintech',
  'real_estate',
  'construction',
  'infrastructure',
  'energy',
  'renewable_energy',
  'oil_and_gas',
  'utilities',
  'manufacturing',
  'automotive',
  'mobility_and_transport',
  'logistics',
  'aerospace_and_defense',
  'tourism_and_hospitality',
  'restaurants',
  'education',
  'human_resources',
  'professional_services',
  'consulting',
  'legal',
  'agriculture',
  'livestock',
  'chemicals',
  'materials',
  'mining',
  'entertainment',
  'gaming',
  'sports',
  'public_services',
];
